import axios from 'axios'

export function fetchTimezones() {
  return (dispatch, getState) => {
    dispatch({
      type: 'TIMEZONES_FETCH',
      payload: axios(`/timezones`)
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/TimezoneActions.js